import { httpClient } from "@/shared/api/http-client"
import { fetchAll } from "@/shared/api/fetch-all"
import { PAGE_LIMIT } from "@/shared/api/pagination"

import type { ListSessionsResponse, SessionLog } from "../model/session-log-types"

export async function listSessionLogs(): Promise<SessionLog[]> {
  const response = await httpClient.get<ListSessionsResponse>(`/api/sessions?limit=${PAGE_LIMIT}`)
  return response.sessions
}

export async function listAllSessionLogs(): Promise<SessionLog[]> {
  return fetchAll(
    (cursor) => {
      const query = cursor
        ? `/api/sessions?limit=${PAGE_LIMIT}&cursor=${encodeURIComponent(cursor)}`
        : `/api/sessions?limit=${PAGE_LIMIT}`
      return httpClient.get<ListSessionsResponse>(query)
    },
    (response) => response.sessions
  )
}
